// app/javascript/controllers/show_modals_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("search controller connected");
  }

  disableBlankInputs() {
    this.element.querySelectorAll("input, select").forEach((element) => {
      if (!element.value) element.disabled = true;
    });
  }

  async skimSearch() {
    const getValue = (selector) => {
      const element = document.querySelector(selector);
      return element?.value?.trim() || "";
    };
    const targets = [
      "material_eq",
      "alloy_eq_any",
      "type_eq_any",
      "form_eq",
      "grade_eq",
      "maker_code_eq",
      "number_cont",
      "in_stock_eq"
    ];

    // 任意の検索項目（elements[]配列として送る）
    const elementNodes = document.querySelectorAll(".elements");
    const elements = Array.from(elementNodes)
      .map((e) => {
        const nameInput = e.querySelector("[name*=name]");
        const maxInput = e.querySelector("[name*=max]");
        const minInput = e.querySelector("[name*=min]");

        if (!nameInput || nameInput.value.trim() === "") return null;

        const element = { name: nameInput.value.trim() };

        if (minInput && minInput.value.trim() !== "") {
          element.min = parseFloat(minInput.value);
        }

        if (maxInput && maxInput.value.trim() !== "") {
          element.max = parseFloat(maxInput.value);
        }

        return element;
      })
      .filter((e) => e !== null);

    const controllerName = document
      .getElementById("search")
      ?.getAttribute("name");
    if (!controllerName) return;

    const params = new URLSearchParams();

    // Ransack用パラメータ
    targets.forEach((target) => {
      const value = getValue(`[id$=_${target}]`);
      if (value) params.append(`q[${target}]`, value);
    });
    // elements[n][key]=value 形式
    elements.forEach((element, i) => {
      params.append(`elements[${i}][name]`, element.name);
      if (element.min !== undefined) {
        params.append(`elements[${i}][min]`, element.min);
      }
      if (element.max !== undefined) {
        params.append(`elements[${i}][max]`, element.max);
      }
    });

    const response = await fetch(`/${controllerName}?${params.toString()}`, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const results = await response.json();

    const modalTitleSpan = document.querySelector(".modal-title span");
    if (modalTitleSpan) {
      modalTitleSpan.textContent = results.size;
    }
  }

  handleInput() {
    clearTimeout(this.inputTimer);
    this.inputTimer = setTimeout(() => this.skimSearch(), 500);
  }

  clearSearch(event) {
    event.preventDefault();

    const selectInputs = this.element.querySelectorAll(".form-select");
    selectInputs.forEach((select) => {
      if (select.tomselect) {
        select.tomselect.clear();
      } else {
        select.value = "";
      }
    });

    const inputs = this.element.querySelectorAll(
      "form input:not([type=submit])"
    );
    inputs.forEach((input) => (input.value = ""));

    this.skimSearch();
  }
}
